.tabs {
  margin-bottom: 16px;
}

.shareRow {
  flex: 1;
  display: flex;
}

.shareInput {
  flex: 1;
}

.linkRow {
  display: flex;
  flex-direction: row;
  color: var(--tuna-palette-text-secondary);
  align-items: center;
}

.embedSection {
  display: flex;
  flex-direction: column;
}

.embedCodeRow {
  display: flex;
  flex-direction: row;
}

.suggestionList {
  margin-top: 4px;
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: 4px;
}
